import { useCallback } from 'react';
import { Grid, Typography } from 'components/ui';
import { useNavigate } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { useModal } from 'contexts/modal';
import { useInfo } from 'contexts/info';
import { useSpace } from 'contexts/space';
import { AddIcon } from 'components/uiIcons';
import { IndexListItemButton } from 'components/styles_components/list';
import { CardTitleTypography } from 'components/styles_components/typography';
import { DashboardLink } from 'utils/link';
import Create from 'components/space/modal/create';

const CreateButton = () => {
  const { addModal, removeModal } = useModal();
  const setInfo = useInfo();
  const navigate = useNavigate();
  const { selectSpace } = useSpace();

  const handleClick = useCallback(() => {
    addModal(
      <Create
        handleClose={() => removeModal()}
        onSuccess={(space) => {
          removeModal();
          setInfo('info.space.created');
          selectSpace(space.id);
          navigate(DashboardLink(), { replace: true });
        }}
      />,
      { disableAutoFocus: true, disableRestoreFocus: true }
    );
  }, [addModal, removeModal, setInfo, selectSpace, navigate]);

  return (
    <IndexListItemButton onClick={handleClick} className="bordered">
      <Grid container spacing={2}>
        <Grid size={{ xs: 11 }}>
          <CardTitleTypography>
            <FormattedMessage id="button.create_workspace" />
          </CardTitleTypography>
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            <FormattedMessage id="button.create_workspace.description" />
          </Typography>
        </Grid>
        <Grid
          size={{ xs: 1 }}
          sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}
        >
          <AddIcon />
        </Grid>
      </Grid>
    </IndexListItemButton>
  );
};

export default CreateButton;
